// extracted by mini-css-extract-plugin
module.exports = {"continue":"TipsContinue_continue_j6TwP"};